import { FRAMEWORK } from '@/lib/brand';
import Reveal from '@/components/Reveal';

export default function LegacyBlueprint() {
  return (
    <section
      id="framework"
      data-testid="framework-section"
      className="relative bg-[#FFFFFF] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="max-w-3xl mb-16 md:mb-24">
          <Reveal>
            <div className="overline text-[#B68A35] mb-6">The Legacy Blueprint&trade;</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-[#0E2238] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
              A Signature Method for<br />
              <span className="italic gold-text">Legacy-Centered</span> Planning.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="text-[#2B2B2B]/70 text-base md:text-lg leading-[1.75] font-light max-w-2xl">
              Four intentional stages that move you from protection to legacy — designed so every
              step feels understood before it is taken.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0E2238]/10">
          {FRAMEWORK.map((step, i) => (
            <Reveal key={step.num} delay={i * 110}>
              <div
                data-testid={`framework-step-${step.title.toLowerCase()}`}
                className="relative bg-white p-8 md:p-10 group hover:bg-[#F7F4EE] transition-colors duration-500 min-h-[340px] flex flex-col h-full"
              >
                <div className="framework-num mb-6 transition-all duration-700 group-hover:-webkit-text-stroke-[rgba(182,138,53,0.9)]">
                  {step.num}
                </div>
                <h3 className="font-serif text-[#0E2238] text-3xl md:text-4xl mb-4 tracking-tight">
                  {step.title}
                </h3>
                <p className="text-[#2B2B2B]/75 text-base leading-[1.7] font-light">
                  {step.copy}
                </p>
                <div className="mt-auto pt-8">
                  <div className="h-px w-0 bg-[#B68A35] group-hover:w-full transition-all duration-[900ms] ease-out" />
                </div>
                {i < FRAMEWORK.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 -translate-y-1/2 w-6 h-px bg-[#B68A35]/40 z-10" />
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <div className="mt-16 flex items-center gap-6">
            <div className="h-px flex-1 bg-[#0E2238]/10" />
            <p className="font-serif italic text-[#0E2238]/55 text-lg text-center">
              Protect &nbsp;·&nbsp; Build &nbsp;·&nbsp; Preserve &nbsp;·&nbsp; Leave
            </p>
            <div className="h-px flex-1 bg-[#0E2238]/10" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
